import { render, staticRenderFns } from "./add_tv.vue?vue&type=template&id=792ac4d5&scoped=true"
import script from "./add_tv.vue?vue&type=script&lang=js"
export * from "./add_tv.vue?vue&type=script&lang=js"
import style0 from "./add_tv.vue?vue&type=style&index=0&id=792ac4d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ac4d5",
  null
  
)

export default component.exports